import { render, staticRenderFns } from "./addMaterialRequisitionDetail.vue?vue&type=template&id=6f9a0778&scoped=true"
import script from "./addMaterialRequisitionDetail.vue?vue&type=script&lang=js"
export * from "./addMaterialRequisitionDetail.vue?vue&type=script&lang=js"
import style0 from "./addMaterialRequisitionDetail.vue?vue&type=style&index=0&id=6f9a0778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9a0778",
  null
  
)

export default component.exports